import { render, staticRenderFns } from "./NotificationUnread.vue?vue&type=template&id=1c5dcd72&scoped=true&"
import script from "./NotificationUnread.vue?vue&type=script&lang=js&"
export * from "./NotificationUnread.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5dcd72",
  null
  
)

export default component.exports